import { Button, DatePicker, Form, Select } from "antd";
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { DepartmentEnum } from "../../../types/transaction";
import { getReportZip } from "../../../services/bill";
import { saveAs } from "file-saver";
import { listDepartmentOption } from "../../../utils/utils";
import { useMainStore } from "../../../stores/main.store";
const { Option } = Select;

type BillDetailProps = {
  intl: any;
};
const BillDetail: React.FC<BillDetailProps> = ({ intl }) => {
  const [isLoading, setIsLoading] = useState(false);
  const store = useMainStore();
  const defaultDepartment = store.departments.includes(
    DepartmentEnum.PHUOC_THANH
  )
    ? DepartmentEnum.PHUOC_THANH
    : DepartmentEnum.THAI_MY;

  const currentMonth = new Date().getMonth() + 1; // Months are 0-indexed in JavaScript
  const onFinish = async (values: any) => {
    try {
      setIsLoading(true);
      // const dto = {
      //   // Provide the necessary data for generating the report
      // };
      const response = await getReportZip(values);

      // console.log("response", response);ww

      // Create a Blob from the response data
      const blob = new Blob([response.data], { type: "application/zip" });

      // Save the Blob as a file using the file-saver library
      saveAs(blob, `baocao_thang${values.month}_coso_${values.department}.zip`);
      // // Create a temporary URL for the Blob
      // const url = window.URL.createObjectURL(blob);

      // // Create a link element
      // const link = document.createElement("a");
      // link.href = url;
      // link.download = `baocao_thang${values.month}_coso_${values.department}.zip`; // Set the filename for the downloaded file

      // // Trigger the click event on the link to start the download
      // link.click();

      // // Clean up the temporary URL and link
      // window.URL.revokeObjectURL(url);
      // link.remove();
      setIsLoading(false);
    } catch (error) {
      console.error("Error downloading report:", error);
      setIsLoading(false);
    }
  };

  return (
    <Form
      labelCol={{ span: 6 }}
      wrapperCol={{ span: 6 }}
      name="billReportForm"
      onFinish={onFinish}
      initialValues={{
        department: defaultDepartment,
        startDate: null,
        endDate: null,
        month: currentMonth,
      }}
    >
      <Form.Item
        name="department"
        label="Cơ Sở"
        rules={[{ required: true, message: "Please select a department" }]}
      >
        <Select>
          {listDepartmentOption
            .filter((department) =>
              store.departments.includes(department.value)
            )
            .map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
        </Select>
      </Form.Item>

      <Form.Item
        name="startDate"
        label="Ngày bắt đầu"
        rules={[{ required: true, message: "Please select a start date" }]}
      >
        <DatePicker />
      </Form.Item>

      <Form.Item
        name="endDate"
        label="Ngày kết thúc"
        rules={[{ required: true, message: "Please select an end date" }]}
      >
        <DatePicker />
      </Form.Item>

      <Form.Item
        name="month"
        label="Tháng"
        rules={[{ required: true, message: "Please select a month" }]}
      >
        <Select>
          {(() => {
            const now = new Date();
            const currentMonth = now.getMonth() + 1;
            const months = [currentMonth];
            if (currentMonth > 1) {
              months.push(currentMonth - 1);
            } else {
              months.push(12); // If January, previous month is December
            }
            return months.map((month) => (
              <Option key={month} value={month}>
                {month}
              </Option>
            ));
          })()}
        </Select>
      </Form.Item>

      <Form.Item style={{ textAlign: "right" }}>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Tạo Báo Cáo
        </Button>
      </Form.Item>
    </Form>
  );
};

export default injectIntl(BillDetail);
